import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/shadcn/card'
import { Button } from '@/components/shadcn/button'
import { ExternalLink, Book, Code, HelpCircle } from 'lucide-react'

export default function DocsPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">文档中心</h1>
        <p className="text-muted-foreground">快速访问技术文档和帮助资源</p>
      </div>

      <div className="grid gap-6 md:grid-cols-2">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">API 文档</CardTitle>
            <Code className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">完整的 API 接口文档</p>
            <Button variant="outline">
              <ExternalLink className="mr-2 h-4 w-4" />
              访问 API 文档
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">集成指南</CardTitle>
            <Book className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">分步骤的集成教程</p>
            <Button variant="outline">
              <ExternalLink className="mr-2 h-4 w-4" />
              查看指南
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">常见问题</CardTitle>
            <HelpCircle className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">常见问题解答</p>
            <Button variant="outline">
              <ExternalLink className="mr-2 h-4 w-4" />
              查看 FAQ
            </Button>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">SDK 下载</CardTitle>
            <Code className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <p className="text-muted-foreground mb-4">各语言 SDK 工具包</p>
            <Button variant="outline">
              <ExternalLink className="mr-2 h-4 w-4" />
              下载 SDK
            </Button>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>快速链接</CardTitle>
          <CardDescription>
            常用文档的快速访问
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid gap-4 md:grid-cols-2">
            <a 
              href="https://docs.memecho.com/quickstart" 
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 border rounded-lg hover:bg-accent transition-colors"
            >
              <h3 className="font-medium">5分钟快速开始</h3>
              <p className="text-sm text-muted-foreground mt-1">最快的集成方式</p>
            </a>
            <a 
              href="https://docs.memecho.com/api-reference" 
              target="_blank"
              rel="noopener noreferrer"
              className="block p-4 border rounded-lg hover:bg-accent transition-colors"
            >
              <h3 className="font-medium">API 参考</h3>
              <p className="text-sm text-muted-foreground mt-1">完整的接口说明</p>
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
